import { z } from 'zod';

/**
 * The NEW badge on menu links (docs/menu-and-report-page-plan.html §5).
 * The portal records the first time someone opens a link after it became
 * new; the badge rule itself lives in the portal (apps/portal/src/lib/new-badge.ts).
 */

/** A menu link: a portal path such as "/academics/report-review". */
const linkSchema = z
  .string()
  .max(100)
  .regex(/^\/[a-z0-9/-]*$/u, 'Not a portal page');

const daySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/u, 'Not a date');

/** POST /api/me/link-opens — "I opened this link, which has been new since `since`". */
export const navLinkOpenSchema = z
  .object({
    link: linkSchema,
    since: daySchema,
  })
  .strict();
export type NavLinkOpenInput = z.infer<typeof navLinkOpenSchema>;

/** Most links one account keeps open-dates for — far more than any menu has. */
export const NAV_LINK_OPENS_MAX = 200;
